import { html } from 'lit';
import { Unlock } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-unlock')
export class PdsIconUnlock extends PdsIcon {
  @state()
  icon = Unlock;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
